import { mapGetters } from 'vuex'

export const PremiumLocksMixin = {
  computed: {
    ...mapGetters('contentProfile',['publishedSubjects']),
  },
  methods: {
    subjectDataFromName(subject) {
      return this.publishedSubjects.find(s => s.subject === subject)
    },
    lockedCategoriesForSubject(subject) {
      return this.subjectDataFromName(subject)?.categories_locked || []
    },
    lockedGradesForSubject(subject) {
      return this.subjectDataFromName(subject)?.grades_locked || []
    },
    isSubjectLocked(subject) {
      return this.subjectDataFromName(subject)?.locked
    },
    isSubjectDomainLocked(subject, category) {
      return this.lockedCategoriesForSubject(subject)?.includes(category)
    },
    isSubjectGradeLocked(subject, grade) {
      return this.lockedGradesForSubject(subject)?.includes(grade)
    },
    areSubjectsLocked() {
      return this.publishedSubjects.some(s => s.locked)
    },
    areSubjectDomainsLocked(subject) {
      return this.lockedCategoriesForSubject(subject)?.length
    },
    areSubjectGradesLocked(subject) {
      return this.lockedGradesForSubject(subject)?.length
    },
    subjectIfUnlocked(subject) {
      return this.isSubjectLocked(subject) ? '' : this.subject
    },
    subjectCategoryIfUnlocked(subject, category) {
      return this.isSubjectDomainLocked(subject, category) ? '' : category
    },
    subjectGradeIfUnlocked(subject, grade) {
      return this.isSubjectGradeLocked(subject, grade) ? '' : grade
    },
    filterLockedBrowseGoalsState(unfilteredState) {
      const filteredState = Object.assign(unfilteredState)
      if (this.isSubjectLocked(filteredState.subject)) {
        delete filteredState.subject
        delete filteredState.subjectDomain
        delete filteredState.grades
        return filteredState
      }
      if (this.isSubjectDomainLocked(filteredState.subject, filteredState.subjectDomain)) {
        delete filteredState.subjectDomain
      }
      if (Array.isArray(filteredState.grades)) {
        filteredState.grades = filteredState.grades.filter(grade => !this.isSubjectGradeLocked(filteredState.subject, grade))
      } else if (this.isSubjectGradeLocked(filteredState.subject, filteredState.grades)) {
        delete filteredState.grades
      }
      return filteredState
    },
    isGoalLocked(goal) {
      const areAllGradesLocked = goal.grades.every(grade => this.lockedGradesForSubject(goal.primary_subject)?.includes(grade))
      const areAllDomainsLocked = goal.domains.every(domain => this.lockedCategoriesForSubject(goal.primary_subject)?.includes(domain))
      return this.isSubjectLocked(goal.primary_subject) || areAllGradesLocked || areAllDomainsLocked
    }
  }
}
